import { useDispatch } from 'react-redux';
import CommanTab from '../../containers/registration/signUpTab';
import { useRegistration } from './RegistrationContext';
import { useEffect } from 'react';
import { deleteReduxProfile } from '../../redux/registration';
import { localStorageRemoveItem } from '../storage/localStorageManager';

const SelectAuthType = () => {
    const dispatch = useDispatch();

    const {
        setAuthType,
        rerenderKey,
        checkIcon,
        setActiveTab,
        setCandidateType,
        setKYCEmail,
        candidateType,
        candidateId,
        managerId,
        setRerenderKey,
        setShowSelectAccountType,
        setDigioSuccessData,
        setPageLoading,
        setShowPasswordTab,
    } = useRegistration();

    useEffect(() => {
        localStorageRemoveItem('selectedDate');
        dispatch(deleteReduxProfile());
    }, []);

    return (
        <div className="card lt-shadow-sm">
            <div className="login-card-body">
                <div className="flex-column">
                    <CommanTab
                        setPageLoading={(item) => setPageLoading(item)}
                        setDigioSuccessData={setDigioSuccessData}
                        setActiveTab={setActiveTab}
                        key={rerenderKey}
                        disableButton={!checkIcon}
                        setAuthType={setAuthType}
                        handleSelect={(key: string, key2: string, value: any) => {
                            setActiveTab(key);
                            setCandidateType(key2);
                            setKYCEmail(value);
                        }}
                        candidateType={candidateType}
                        setShowPasswordTab={setShowPasswordTab}
                        setShowSelectAccountType={setShowSelectAccountType}
                        goToRegistration={() => {
                            if (candidateId) {
                                setActiveTab('account-details');
                                setCandidateType('candidate');
                            } else if (managerId) {
                                setActiveTab('account-details');
                                setCandidateType('company');
                            } else {
                                setActiveTab('select-account');
                                setRerenderKey(rerenderKey + 1);
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default SelectAuthType;
